import { ReactElement } from 'react';
import {
  PriceBreak,
  TransactionalCurrency,
  Website
} from '../../../types/generated';
import formatCurrency from '../../../utilities/formatCurrency';

interface PriceBreaksProps {
  priceBreaks: PriceBreak[] | null;
  transactionalCurrency: TransactionalCurrency;
  website: Website;
  showSecondaryPrice: boolean;
  updateQuantity: (value: number) => void;
}

export default function PriceBreaks({
  priceBreaks,
  transactionalCurrency,
  showSecondaryPrice,
  updateQuantity
}: PriceBreaksProps): ReactElement {
  function formatPriceBreakPrices(priceBreak: PriceBreak) {
    return (
      <>
        <div className="product-price product-price">
          <span className="product-price">
            {formatCurrency(
              priceBreak.pricingInfo.primaryPrice.value,
              transactionalCurrency
            )}{' '}
            <span className="per-item">each</span>
          </span>
        </div>
      </>
    );
  }
  const onHandleClick = (units: number) => {
    updateQuantity(units);
  };

  function formatTotalOfferPrice(priceBreak: PriceBreak) {
    var totalPrice =
      priceBreak.pricingInfo.primaryPrice.value * priceBreak.units;
    var totalSecondaryPrice =
      priceBreak.pricingInfo.secondaryPrice.value * priceBreak.units;
    return (
      <>
        <div className="product-price product-price--primary">
          <span className="d-none">{'GBP'}</span>
          <span className="product-price--primary-value">
            {formatCurrency(totalPrice, transactionalCurrency)}
          </span>
          {!showSecondaryPrice && (
            <span className="price-primary-text">
              {priceBreak.pricingInfo.primaryPriceText}
            </span>
          )}
        </div>

        {showSecondaryPrice && (
          <div className={`product-price product-price--secondary`}>
            <span className="d-none">{'GBP'}</span>
            <span>
              {formatCurrency(totalSecondaryPrice, transactionalCurrency)}
            </span>{' '}
            <span className="price-secondary-text">
              {priceBreak.pricingInfo.secondaryPriceText}
            </span>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="purchase-options">
      <h6>Buy More Save More</h6>
      <div className="price-breaks">
        <div className="price-breaks__prices">
          {priceBreaks?.map((priceBreak: PriceBreak) => (
            <div
              key={priceBreak.units}
              className="price-break"
              onClick={() => onHandleClick(priceBreak.units)}
            >
              <div className="price-break-container price-break-container--background">
                <div className="left-column">
                  <span className="price-break__offer">
                    <strong>Buy {priceBreak.units}</strong>
                    <small className="text-small">{` (or more)`}</small>
                  </span>
                  <span className="price-break__price">
                    {formatPriceBreakPrices(priceBreak)} {'  '}
                  </span>
                </div>
                <div className="right-column">
                  <span className="savings">
                    Save up to{' '}
                    {Math.floor(priceBreak.pricingInfo.savingsPercentage)}%
                  </span>
                </div>
              </div>
              <div className="product-total-savings price-break-container">
                {formatTotalOfferPrice(priceBreak)} {'  '}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
